<div class="container">
  <div class="row unknown-caller">
    <div class="col-md-3 col-lg-2 unknown-caller-left">


      <div class="persistant-info">
        <p class="client-name"> {{getClientName()}} </p>
        <div class="client-cust-name">
          Unknown Caller
        </div>
        <div class="time-duration">
          <span class="clock-icon"><i class="fa-light fa-clock"></i></span>
          <span class="time">{{getTimerVal()}}</span>
          <span class="duration">Started {{getStartTime() }}</span>
        </div>
        <div class="account-info">
          <p class="auth-status unsecured">
            <span> Unsecured </span>
          </p>
        </div>

      </div>


      <div class="dashboard-left-nav" pos-relative>
        <span class="section-divider"></span>

        <app-loader *ngIf="rootScope.activeCustTab?.unknownCallerLeftNav?.unknownCallerLeftNavLoader "
          [loaderType]="loaderType"
          [loaderMsg]="rootScope.activeCustTab?.unknownCallerLeftNav?.unknownCallerLeftNavLoaderMsg"></app-loader>

        <section *ngIf="rootScope.activeCustTab.unknownCallerLeftNav.unknownCallerLeftNavError" class="error-wrapper">
          <f-alert variant="error" class="error-without-heading">
            <p class="full-width">
              {{errorMsg}}
            </p>
          </f-alert>
          <button mat-button color="primary" (click)="getUnknownCallerLeftNavData()" title="Refresh"
            class="btn-refresh1">
            Refresh
            <i class="fa-solid fa-arrows-rotate"></i>
          </button>
        </section>

        <div class="accordion-tab" *ngFor="
            let menu of rootScope.activeCustTab.unknownCallerLeftNav.unknownCallerNavBarData ;
            let menuLastItem = last
          ">
          <mat-accordion>
            <mat-expansion-panel [expanded]="rootScope.activeCustTab.unknownCallerLeftNav.selectedMenu == menu?.id">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <i [ngClass]="menu.icon"></i> {{ menu.heading }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="subLinks">
                <li *ngFor="let subMenu of menu?.subMenuList | sortBy : 'heading'">
                  <span (click)="activateLeftMenu(menu, subMenu)" [ngClass]="{
                    active: rootScope.activeCustTab.unknownCallerLeftNav.selectedSubMenu == subMenu.id
                  }" [ngClass]="(!subMenu.linkEnable)?'disabledLink':''">
                    <button [disabled]='!subMenu.linkEnable' class="navlinks">{{ subMenu?.heading }}</button>

                  </span>
                </li>
              </ul>
            </mat-expansion-panel>
          </mat-accordion>
          <span *ngIf="!menuLastItem" class="section-divider"></span>
        </div>
      </div>
    </div>

    <div class="col-md-9 col-lg-10 unknown-caller-right">
      <h4>Unknown Caller Detail</h4>
      <span *ngIf="rootScope.unknownCallerTypeAPIFailure">
        <section class="error-wrapper">
          <f-alert variant="error">
            {{commonErrorMsg}}
            <button (click)="apiService.getUnknownCallerTypes()" class="btn-alert">Try again</button>
          </f-alert>
        </section>
      </span>
      <div class="description">
        <p>Please complete this required information related to the unknown caller</p>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-8">

          <div class="row">
            <div class="col-md-12 col-lg-6">
              <mat-form-field appearance="fill" class="component-box">
                <mat-label>Unknown Caller Type</mat-label>
                <mat-select [(ngModel)]="rootScope.activeCustTab.wrapUpData.unknownCallerType"
                  (selectionChange)="onUnknownCallerTypeChange($event)" disableRipple placeholder="unknownCaller">
                  <mat-option *ngFor="let type of rootScope.unknownCallerTypeList" [value]="type.fieldValue">
                    {{ type.fieldValueDescription }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <mat-form-field appearance="fill" class="component-box">
                <mat-label>Caller Name</mat-label>
                <input matInput [(ngModel)]="rootScope.activeCustTab.wrapUpData.unknownCustomerName" />
              </mat-form-field>
            </div>
            <div class="col-md-12 col-lg-6">
              <mat-form-field appearance="fill" class="component-box">
                <mat-label>Phone Number</mat-label>
                <input [disabled]="true" [(ngModel)]="rootScope.activeCustTab.tabData.phoneNumber" matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="card-row row-margin add-topic-row">
                <div class="add-topic-header">
                  <span class="data-label">Topics </span>
                  <div class="add-topic-controls">
                    <button mat-icon-button class="add-topic" title="Add Topic"
                      [disabled]="rootScope.activeCustTab.wrapUpData.wrapupTopicList.length>=ten"
                      (click)="addTopicModal()">
                      <i class="fa-regular fa-circle-plus"></i>
                    </button>

                    <button mat-icon-button class="make-primary" title="Make Primary"
                      [disabled]="rootScope.activeCustTab.wrapUpData.wrapupTopicList?.length==0"
                      (click)="makePrimary(topicIndex)">
                      <i class="fa-solid fa-star-of-life"></i>
                    </button>

                    <button mat-icon-button class="delete-topic" title="Delete Topic"
                      [disabled]="rootScope.activeCustTab.wrapUpData.wrapupTopicList?.length==0 || isDefaultTopic(topicIndex)"
                      (click)="deleteWrapupTopic(topicIndex)">
                      <i class="fa-regular fa-trash-can"></i>
                    </button>

                  </div>
                </div>

                <span class="add-topic-container">
                  <ng-container
                    *ngFor="let data of rootScope.activeCustTab.wrapUpData.wrapupTopicList; let index =index">
                    <p (click)="wrapupSelectedRow(data)" [ngClass]="{ 'selected': topicIndex.id === data?.id }">
                      <span class="primary-sign"
                        *ngIf="rootScope.activeCustTab.wrapUpData.primaryTopic==data?.domain + topicArrow + data?.topic + topicArrow + data?.subTopic">*</span>
                      {{data?.domain}} {{topicArrow}} {{data?.topic}} {{topicArrow}} {{data?.subTopic}}
                    </p>
                  </ng-container>

                </span>
                <span class="topic-notes"><strong>Note</strong>: You can choose min 1 topic and max 10 topics.</span>

              </div>

              <div class="card-row topic-comments">
                <div class="add-topic-header">
                  <span class="data-label"> Comments</span>

                </div>
               
                <div class="comments-box">
                  <f-textarea spellcheck="true" [value]="rootScope.activeCustTab.wrapUpData.comments"
                    [(ngModel)]="rootScope.activeCustTab.wrapUpData.comments" (textareaChanged)="onTextareaChanged($event)"></f-textarea>
                </div>

                
        <div class="card-row ai-call-summary">

          <f-loading size="small"  *ngIf="rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryFetching"></f-loading>

          <button class="link"  [ngClass]="{'disabledLink': checkGetSummaryButtonEnabledOrDisabled()}" [disabled]="checkGetSummaryButtonEnabledOrDisabled()" (click)="onClickSummaries()"><span *ngIf="!rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryFetching"><i class="fa-light fa-sparkles"></i></span>Retrieve AI Summary</button>
        
          <div class="error-wrapper" *ngIf="checkSummaryErrorMessage() || rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryApiError">    
            
            <f-alert variant="error" *ngIf="rootScope.activeCustTab?.aiSummaryStatus?.isCallSummaryApiError">
                  <p> There was problem loading the data. Press the button to try again.</p>
            </f-alert>

            <f-alert variant="info" in-container *ngIf="checkSummaryErrorMessage()">
              <p><strong>AI Summary Not Available.</strong><br>
              Please enter your own topics and comments and close the account. If the summary appears in Genesys prior to you closing the account, you may click the button to retry.</p>
            </f-alert>
        </div>


        
        </div>
              
                <div class="card-row close-account">

                  <f-button class="btn-close" text="Submit" title="Submit" type="button"
                    [disabled]="!updateWrapupStatus()" variant="progressive" (click)="closeAccountButtonClicked()">
                  </f-button>

                  <f-button class="btn-back" text="Back" title="Back" type="button" variant="action"
                    (click)="hideUnknowncallerTab()">
                  </f-button>
                </div>
                <div class="col-md-12" *ngIf='enableSyncLink()'>
                <div [ngClass]="{'error-gap':rootScope.activeCustTab?.wrapUpData?.callStatus?true:false}">
                  <section *ngIf="rootScope.activeCustTab?.wrapUpData?.callStatus"
                  class="error-wrapper">
                   <f-alert variant="error" class="error-without-heading">
                     <p class="full-width">
                       <strong>Interaction status could not sync.</strong> Try syncing again or contact support if this issue persists.
                     </p>
                   </f-alert>
                 
                 </section>
                </div>
                  <div class="refresh-link-wrapup">
                    <button class="link" (click)="onClickLiveStatus()">Sync interaction status between ALIS and Care Portal.</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <app-customer-account-dialog id="addTopic" *ngIf="showAddTopicModal">

        <div id="content">
          <div class="topic-header alert-header">
            <h6>Add Topics</h6>
            <div class="close-btn">
              <button mat-icon-button mat-dialog-close (click)="closeAlertPopup()">
                <i class="fa-sharp fa-regular fa-xmark-large"></i>
              </button>
            </div>
          </div>

          <span *ngIf="rootScope.domainListAPIFailure">
            <section class="error-wrapper">
              <f-alert variant="error">
                {{commonErrorMsg}}
                <button (click)="getDomainList()" class="btn-alert">Try again</button>
              </f-alert>
            </section>
          </span>
          <f-alert variant="info" class="status-msg " *ngIf="duplicateTopic?.domain">Please choose a unique
            combination of <b>
              {{duplicateTopic?.domain}} >> {{duplicateTopic?.topic}} >> {{duplicateTopic?.subTopic}}.</b>
          </f-alert>
          <div class="container form-scroll">
            <div class="row">
              <div class="col-md-12">
                <p>Select Topic</p>
              </div>
            </div>
            <form id="add-topic-form" [formGroup]="topicForm" (ngSubmit)="addTopic()">
              <div class="row">
                <div class="col-md-4">
                  <mat-form-field appearance="fill" class="component-box">
                    <mat-label>Domain (Required)</mat-label>
                    <mat-select disableRipple disableOptionCentering formControlName="domain">
                      <mat-option *ngFor="let domain of domainList" [value]="domain?.topicName"
                        (onSelectionChange)="getTopicList(domain,$event)">
                        {{ domain?.topicName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="fill" class="component-box">
                    <mat-label>Topic (Required)</mat-label>
                    <mat-select disableRipple disableOptionCentering formControlName="topic"
                      [disabled]="topicList.length==0">
                      <mat-option *ngFor="let topic of topicList" [value]="topic.topicName"
                        (onSelectionChange)="getSubTopicList(topic,$event)">
                        {{ topic.topicName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="fill" class="component-box">
                    <mat-label>Subtopic (Required)</mat-label>
                    <mat-select disableRipple disableOptionCentering formControlName="subTopic"
                      [disabled]="subTopicList.length==0">
                      <mat-option *ngFor="let subtopic of subTopicList" [value]="subtopic.topicName">
                        {{ subtopic.topicName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 cta-row">
                  <f-button text="Add" title="Add" type="button" variant="progressive" (click)="addTopic()"
                    [ngClass]="{disableBtn:(topicForm.invalid || tableData.length>=ten || (rootScope.activeCustTab.wrapUpData.wrapupTopicList.length+tableData.length>=ten))}"
                    [disabled]="topicForm.invalid || tableData.length>=ten || (rootScope.activeCustTab.wrapUpData.wrapupTopicList.length+tableData.length>=ten)">
                  </f-button>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-md-12">
                <div class="topic-cta">

                  <button mat-icon-button class="delete-topic" title="Delete Topic" [disabled]="tableData.length==0"
                    (click)="deleteTopic(index)">
                    <i class="fa-regular fa-trash-can"></i>
                  </button>

                </div>

                <div class="table-container">


                  <mat-table [dataSource]="dataSource">

                    <!-- Domain Column -->
                    <ng-container matColumnDef="domain">
                      <mat-header-cell *matHeaderCellDef> Domain </mat-header-cell>
                      <mat-cell *matCellDef="let element"> {{element.domain}} </mat-cell>
                    </ng-container>

                    <!-- topic Column -->
                    <ng-container matColumnDef="topic">
                      <mat-header-cell *matHeaderCellDef> Topic </mat-header-cell>
                      <mat-cell *matCellDef="let element"> {{element.topic}} </mat-cell>
                    </ng-container>

                    <!-- Subtopic Column -->
                    <ng-container matColumnDef="subTopic">
                      <mat-header-cell *matHeaderCellDef> Subtopic </mat-header-cell>
                      <mat-cell *matCellDef="let element"> {{element.subTopic}} </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns; let i = index" (click)="selectedRow(i)"
                      [ngClass]="{ 'selected-row': i === index }"></mat-row>
                  </mat-table>
                  <div class="no-result hide1" *ngIf="tableData.length==0">
                    <p>Please add topics on the form above. </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="button-controls">
            <f-button text="Clear all" title="Clear all" type="button" variant="action" (click)="clearTopic()"></f-button>
            <f-button text="Submit" title="Submit" type="button" variant="progressive" [ngClass]="{disableBtn:tableData.length==0}"
              [disabled]="tableData.length==0" (click)="submitTopic()"></f-button>
          </div>
         
        </div>
      </app-customer-account-dialog>
    </div>
  </div>
</div>